// @flow
import { combineReducers } from 'redux';
import drawer from './drawer';
import overlay from './overlay';
import popup from './popup';
import sidebar from './sidebar';
import createChat from './createchat';
import contextbar from './contextbar';
import online from './online';
import formInProgress from './formInProgress';
import pdfViewer from './pdfViewer';
import imageViewer from './imageViewer';
import locale from './locale';
import success from './success';
import error from './error';
import theme from './theme';
import defaultTab from './defaultTab';
import videoCallEndPopup from './videoCallEndPopup';

export default combineReducers({
  drawer,
  overlay,
  popup,
  sidebar,
  online,
  formInProgress,
  pdfViewer,
  imageViewer,
  locale,
  success,
  error,
  contextbar,
  createChat,
  theme,
  defaultTab,
  videoCallEndPopup
});



// WEBPACK FOOTER //
// ./src/redux/ui/index.js